import i18next from 'i18next'

import { IS_APP_VISIBLE_STORAGE_KEY } from '@/constants/common'

export const createStatusBrowserNotification = ({ title, message }: any) => {
  const t = i18next.t

  const isAnyTabActive =
    localStorage.getItem(IS_APP_VISIBLE_STORAGE_KEY) === 'true'
  if (isAnyTabActive) return

  Notification?.requestPermission()?.then(() => {
    const notification = new Notification(title, {
      body: message,
      icon: '/images/yassir-192.png',
      // image: '/images/yassir-192.png',
      tag: title
    })
    notification.onclick = () => {
      window.open(`${window.location.origin}/orders/new`, '_blank')
    }
  })
}
